export default __webpack_public_path__ + "static/media/playstore.7b6c39e8.svg";